/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Terms_CrumbInputs */

const en_auth_terms_crumb = /** @type {(inputs: Auth_Terms_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

const pl_auth_terms_crumb = /** @type {(inputs: Auth_Terms_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Auth_Terms_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_terms_crumb = /** @type {((inputs?: Auth_Terms_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Terms_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_terms_crumb(inputs)
	return en_auth_terms_crumb(inputs)
});